module.exports = __webpack_public_path__ + "img/trello.319fba32.svg";